import React from 'react';
import './AwesomeHero.css';

const AwesomeHero: React.FC = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="awesome-hero">
      <div className="awesome-hero-container">
        <div className="awesome-hero-content">
          <span className="awesome-hero-badge">Korepetycje z matematyki online</span>

          <h1 className="awesome-hero-title">
            Zbuduj pewnosc siebie<br />
            <span className="awesome-hero-highlight">w matematyce</span>
          </h1>

          <p className="awesome-hero-subtitle">
            Dolacz do ponad 500 uczniow, ktorzy osiagneli sukces na maturze.
            Sprawdzone metody, doswiadczeni nauczyciele, konkretne wyniki.
          </p>

          <div className="awesome-hero-buttons">
            <button onClick={scrollToContact} className="awesome-btn awesome-btn-primary awesome-btn-lg">
              Rozpocznij za darmo
            </button>
            <button onClick={scrollToPricing} className="awesome-btn awesome-btn-secondary awesome-btn-lg">
              Zobacz cennik
            </button>
          </div>

          <div className="awesome-hero-trust">
            <div className="awesome-hero-trust-item">
              <svg className="awesome-hero-check" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              <span>Pierwsza lekcja gratis</span>
            </div>
            <div className="awesome-hero-trust-item">
              <svg className="awesome-hero-check" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              <span>Bez zobowiazan</span>
            </div>
            <div className="awesome-hero-trust-item">
              <svg className="awesome-hero-check" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              <span>Wyniki w 8 tygodni</span>
            </div>
          </div>
        </div>

        <div className="awesome-hero-visual">
          <div className="awesome-hero-stats-preview">
            <div className="awesome-preview-card">
              <div className="awesome-preview-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              <div className="awesome-preview-content">
                <span className="awesome-preview-value">98%</span>
                <span className="awesome-preview-label">zdawalnosc matur</span>
              </div>
            </div>

            <div className="awesome-preview-card">
              <div className="awesome-preview-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
                  <polyline points="17 6 23 6 23 12" />
                </svg>
              </div>
              <div className="awesome-preview-content">
                <span className="awesome-preview-value">+35 pkt</span>
                <span className="awesome-preview-label">sredni wzrost wynikow</span>
              </div>
            </div>

            <div className="awesome-preview-card">
              <div className="awesome-preview-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 00-3-3.87" />
                  <path d="M16 3.13a4 4 0 010 7.75" />
                </svg>
              </div>
              <div className="awesome-preview-content">
                <span className="awesome-preview-value">500+</span>
                <span className="awesome-preview-label">zadowolonych uczniow</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AwesomeHero;
